import BoostAdReportRow from 'app/shared/model/BoostAdReportRow';
import Listing from 'app/shared/model/Listing';

const BoostAdReport = ({
    totalCost = null,
    stats = [],
    propertyDetails = {},
    isEstimate = false,
} = {}) => ({
    totalCost: Number(totalCost),
    rows: stats.map(item => BoostAdReportRow(item)),
    propertyDetails: Object.keys(propertyDetails).reduce((acc, key) => {
        acc[key] = Listing(propertyDetails[key]);
        return acc;
    }, {}),
    isEstimate: Boolean(isEstimate),
});

export default BoostAdReport;
